module.exports = __webpack_public_path__ + "static/media/tropiquesfm.a99e4f34.png";